import { Subscription } from 'rxjs/Rx';
import { Saveapi } from './../../models/plan/saveapi';
import { EstimatesItem } from './../../models/plan/estimatesItem';
import { PlanService } from './../../services/plan.service';
import { resultitem } from './../../models/plan/mitsumoriItems';
import { PlanMainService } from './../service/plan-main.service';
import { Kyotens, Kyostat } from './../../models/plan/kyotens';
import { Staffs, Stuffstat } from './../../models/plan/staffs';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  Input
} from '@angular/core';
import { log } from 'util';
import { UtilService } from '../../services/util.service';
import { DataService } from '../../services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-quotation-search',
  templateUrl: './quotation-search.component.html',
  styleUrls: ['./quotation-search.component.css']
})
export class QuotationSearchComponent implements OnInit, OnDestroy {
  @Input() showCustomerSearch: boolean;
  @Output('close') close: any = new EventEmitter<any>();
  @Output() mitsumoriNoValue: any = new EventEmitter<any>();
  @Output() datamitsumori: any = new EventEmitter<any>();

  public showQuot2 = false;
  public selectedRow: number;
  public listData: resultitem[] = [];
  public estimatesItem: EstimatesItem;

  public display = false;

  public datestring = '';

  public makerData: any[] = [];
  public filtermakerData: any[] = [];
  public makerIndexForClear: any;
  public displayModel = false;
  public makerdisplay = false;
  /////////////////////
  public modelData: any[] = [];
  public filtermodelData: any[] = [];
  public modeldisplay = false;
  public modelIndexForClear: any;

  ///////////////////////////
  public gradesdata: any;
  public gradesDispaly = false;
  public gradesIndexForClear: any;

  public mitsumoriNovalue = '';
  public hanbaiKyotenCd: string = null;
  public hanbaiKyotenNm: string = null;
  public hanbaikyotenCd = '';
  public hanbaiTantouCd = '';
  public hanbaiTantouNm: string = null;
  public hanbaiDestinationKanji = '';
  public hanbaiDestinationFn = '';

  // public newcarfig = '1';
  public selectitem: resultitem = {};
  public zaikoShatenCd = '';
  public zaikoKanriCd = '';
  public useCar = 0;

  public selectdata: resultitem;

  private estimatesItemSubscription: Subscription;
  private makersSubscription: Subscription;
  private modelsSubscription: Subscription;
  private makerFilterSubscription: Subscription;
  private modelFilterSubscription: Subscription;
  private listdatacustomersSubscription: Subscription;

  public shatendisplay = false;
  public shatens: any[] = [];

  public tantoudisplay = false;
  public tantous: Stuffstat[] = [];

  public kyotendisplay = false;
  public kyotens: Kyostat[] = [];

  public numSearch: number;
  public carvalue: any = [
    {
      makerNm: null,
      makerCd: null,
      modelCd: null,
      modelNm: null,
      gradeNm: null,
      gradeCd: null
    }
  ];

  public testEmit: any = '';

  public clearCheckMaker = false;
  public clearCheckModel = false;
  public dataTotalSize: number;
  public searchChunk: any[];
  public page = 0;

  public dataSharyou = [
  {kbn: null, text: ''},
  {kbn: 1, text: '新車'},
  {kbn: 2, text: '中古'},
  {kbn: 3, text: '未使用車'}];

  public sharyouKbn: number = 1;

  constructor(
    private _planService: PlanMainService,
    private planService: PlanService,
    private _data: DataService,
    private router: Router
  ) { }
  ngOnInit() {
    this.getPlanUsecar();
    this.getQoutsearch();
    if (this._data && this._data.staffData) {
      this.zaikoShatenCd = this._data.staffData.shatenCd;
    }
  }

  getPlanUsecar() {
    this.useCar = 0;
    this.planService.passingPlanUsedcar
      .subscribe(e => {
        if (e !== undefined && e !== null && e !== '') {
          this.useCar = +e;
          if (this.useCar === 0) {
            if (this.router.url !== '/home') {
              this.dataSharyou = this.dataSharyou.filter(item => item.kbn === 1);
            }
            this.sharyouKbn = 1;
          } else if (this.useCar === 1) {
            this.dataSharyou = this.dataSharyou.filter(item => item.kbn === 2);
            this.sharyouKbn = 2;
          } else {
            this.dataSharyou = this.dataSharyou.filter(item => item.kbn !== 1);
            this.sharyouKbn = null;
          }
        }
      })
      .unsubscribe();
  }

  onChangeNewcarflag(event) {
    // this.newcarfig = event;
    console.log(event);
  }

  onClose() {
    this.close.emit();
  }

  closeFilter() {
    this.showQuot2 = false;
  }

  onShowQuot2(e: number) {
    this.showQuot2 = true;
    this.numSearch = e;
  }

  getQoutsearch() {
    this.listdatacustomersSubscription = this._planService.listdatacustomers.subscribe(
      val => {
        if (this.numSearch === 1) {
          this.hanbaiDestinationKanji =
            val.kojinNmKjSei + ' ' + val.kojinNmKjMei;
        } else if (this.numSearch === 2) {
          this.hanbaiDestinationFn = val.kojinNmKnSei + ' ' + val.kojinNmKnMei;
        }
      }
    );
  }

  setClickedRow(index: number, data: any) {

    if (this.selectedRow !== index) {
      this.selectedRow = index;
      this.selectdata = data;
    } else {
      this.selectedRow = null;
      this.selectdata = null;
    }

    this.selectitem = data;
  }

  onDbclickTable(data: resultitem) {
    this._data.removeOrderNoMitsumoriNo();
    this.selectitem = data;
    this.mitsumoriNoValue.emit(data.mitsumoriNo);
    this.datamitsumori.emit(data);
    this._data.saveData('mitsumorino', data);
    this.close.emit();
  }

  onConfirm() {
    if (this.selectitem != null) {
      this.mitsumoriNoValue.emit(this.selectitem.mitsumoriNo);
      this.datamitsumori.emit(this.selectitem);
      this._data.saveData('mitsumorino', this.selectitem);
      this.close.emit();
    }
  }

  onzeroFill1(event) {
    if (this.mitsumoriNovalue) {
      this.mitsumoriNovalue = event;
    }
  }

  onzeroFill2(event) {
    if (this.zaikoKanriCd) {
      this.zaikoKanriCd = event;
    }
  }

  onsearching() {
    this.selectdata = null;
    this.selectedRow = null;
    this.dataTotalSize = 0;
    this.listData = null;
    if (this.selectitem.mitsumoriNo == undefined) {
      this.selectitem.mitsumoriNo = '';
    }
    if (this.carvalue.makerCd == undefined) {
      this.carvalue.makerCd = '';
    }
    if (this.carvalue.modelCd == undefined) {
      this.carvalue.modelCd = '';
    }

    // if (this.useCar == 1 && this.newcarfig == '') {
    //   this.newcarfig = '1';
    // }

    this.estimatesItem = {
      // newcarFlg: this.newcarfig,
      sharyouKbn: this.sharyouKbn,
      mitsumoriYmd: this.datestring,
      mitsumoriNo: this.mitsumoriNovalue,
      zaikoShatenCd: this.zaikoShatenCd,
      zaikoKanriCd: this.zaikoKanriCd,
      hanbaikyotenCd: this.hanbaiKyotenCd, // this.hanbaikyitenCd,
      hanbaiTantouCd: this.hanbaiTantouCd,
      hanbaiDestinationKanji: this.hanbaiDestinationKanji,
      hanbaiDestinationFn: this.hanbaiDestinationFn,
      makerCd: this.carvalue.makerCd,
      ModelCd: this.carvalue.modelCd
    };

    this.estimatesItemSubscription = this._planService
      .getestimatesItem(this.estimatesItem)
      .subscribe(data => {
        console.log(data);
        if (data !== undefined && data != null) {
          const newlistData = [...data.result]; // copy array to slice;
          const arr = [];
          const size = 10;
          while (newlistData.length > 0) {
            arr.push(newlistData.splice(0, size));
          }
          this.page = 0;
          this.searchChunk = arr;
          // console.log(this.page);
          // console.log(this.searchChunk[this.page], 'searchChunk');
          this.listData = this.searchChunk[0];
          this.dataTotalSize = data.totalSize;
        } else {
          this.listData = null;
        }
      });
  }

  onselectDate(event: any) {
    // console.log(event);
    this.datestring = this._planService.setStringdate('YYYYMMDD', event.value);
  }

  onDatevalue(event) {
    if (event && event.value) {
      this.datestring = this._planService.setStringdate(
        'YYYYMMDD',
        event.value
      );
    } else {
      this.datestring = null;
    }
  }

  oncloseDialog(event: any) {
    this.display = false;
    this.makerdisplay = false;
    this.modeldisplay = false;
    this.gradesDispaly = false;
    this.kyotendisplay = false;
    this.tantoudisplay = false;
  }

  onShowdialog() {
    this.display = true;
    this.makerdisplay = true;
    if (this.makerData.length === 0) {
      this.makersSubscription = this.planService
        .getMakersDataCar()
        .subscribe(res => {
          if (res) {
            this.makerData.push({
              makerCd: '00000',
              makerNm: '未選択',
              stat: false
            });
            res.forEach((val, i) => {
              this.makerData.push({
                makerCd: val.makerCd,
                makerNm: val.makerNm,
                stat: false
              });
            });
          } else {
            this.makerData = res;
          }
        });
    }
  }

  showDialogModel() {
    this.display = true;
    this.modeldisplay = true;
    this.makerdisplay = false;
    if (this.modelData.length === 0) {
      this.modelsSubscription = this.planService
        .getModelsDataCar(this.carvalue.makerCd)
        .subscribe(res => {
          if (res) {
            this.modelData.push({
              modelNm: '未選択',
              modelCd: '00000',
              stat: false
            });
            res.forEach((val, i) => {
              this.modelData.push({
                modelNm: val.modelNm,
                modelCd: val.modelCd,
                stat: false
              });
            });
          } else {
            this.modelData = res;
          }
        });
    }
  }

  filterMakerList(index: any) {
    this.filtermakerData = this.filtermakerData.filter(e => e.stat !== false);
      this.makersSubscription = this.planService
        .getMakersDataCar(index)
        .subscribe(res => {
          if (res) {
            this.makerData = [];
            this.makerData.push({
              makerCd: '00000',
              makerNm: '未選択',
              stat: false
            });

            res.forEach((val, i) => {
              if (
                this.filtermakerData.length !== 0 &&
                this.filtermakerData[0].makerCd === val.makerCd
              ) {
                this.makerData.push({
                  makerCd: val.makerCd,
                  makerNm: val.makerNm,
                  stat: true
                });
              } else {
                this.makerData.push({
                  makerCd: val.makerCd,
                  makerNm: val.makerNm,
                  stat: false
                });
              }
            });
          } else {
            this.makerData = res;
          }
        });
  }

  filterModelList(index: any) {
    this.filtermodelData = this.filtermodelData.filter(e => e.stat !== false);
      this.modelsSubscription = this.planService
        .getModelsDataCar(this.carvalue.makerCd, index)
        .subscribe(res => {
          if (res) {
            this.modelData = [];
            this.modelData.push({
              modelNm: '未選択',
              modelCd: '00000',
              stat: false
            });
            res.forEach((val, i) => {
              if (
                this.filtermodelData.length !== 0 &&
                this.filtermodelData[0].modelCd === val.modelCd
              ) {
                this.modelData.push({
                  modelNm: val.modelNm,
                  modelCd: val.modelCd,
                  stat: true
                });
              } else {
                this.modelData.push({
                  modelNm: val.modelNm,
                  modelCd: val.modelCd,
                  stat: false
                });
              }
            });
          } else {
            this.modelData = res;
          }
        });
  }

  makerSelected(maker: any, event: any) {
    if (maker.makerCd == '00000') {
      for (let i = 0; i < this.makerData.length; i++) {
        this.makerData[i].stat = false;
      }
      this.makerData.forEach((val, i) => {
        if (maker.makerCd !== val.makerCd) {
          this.makerData[i].stat = false;
        }
      });

      setTimeout(() => {
        this.carvalue.makerNm = '';
        this.carvalue.makerCd = '';
        this.carvalue.modelNm = '';
        this.carvalue.modelCd = '';
        this.oncloseDialog(event);
        this.makerData = [];
        this.modelData = [];
      }, 500);
    } else {
      this.carvalue.makerNm = maker.makerNm;
      this.carvalue.makerCd = maker.makerCd;
      setTimeout(() => {
        this.carvalue.modelCd = null;
        this.carvalue.modelNm = null;
        this.modelData = [];
        this.carvalue.gradeNm = null;
        this.oncloseDialog(event);
      }, 500);
    }
    // send value to services for BehaviorSubject
    this.filtermakerData = this.makerData;
  }

  checkedMakerSelected(event: any, i: any) {
    this.makerIndexForClear = i;
    if (this.makerData[i].stat == event) {
      this.makerData[i].stat = false;
      this.carvalue.makerNm = null;
      this.carvalue.makerCd = null;
    } else {
      this.makerData.forEach((e, index) => {
        if (i === index) {
          this.makerData[index].stat = true;
        } else {
          this.makerData[index].stat = false;
        }
      });
    }
  }

  modelSelected(model: any, event: any) {
    if (model.modelCd == '00000') {
      // for (let i = 0; i < this.modelData.length; i++) {
      //   this.modelData[i].stat = false;
      // }
      // console.log(this.modelData);
      this.modelData.forEach((val, i) => {
        if (model.modelCd !== val.modelCd) {
          this.modelData[i].stat = false;
        }
      });
      setTimeout(() => {
        this.display = false;
        this.modeldisplay = false;
        this.carvalue.modelNm = '';
        this.carvalue.modelCd = '';
        this.oncloseDialog(event);
        this.modelData = [];
        // this.checkedModelSelected(events, indexs);
      }, 500);
    } else {
      this.carvalue.modelCd = model.modelCd;
      this.carvalue.modelNm = model.modelNm;
      setTimeout(() => {
        this.carvalue.gradeNm = null;
        this.oncloseDialog(event);
        // this.checkedModelSelected(events, indexs);
      }, 500);
    }
    // console.log(this.carvalue.modelNm);
    this.filtermodelData = this.modelData;
  }

  checkedModelSelected(event: any, i: any) {
    this.modelIndexForClear = i;
    if (this.modelData[i].stat == event) {
      this.modelData[i].stat = false;
      this.carvalue.modelNm = '';
      this.carvalue.modelCd = '';
    } else {
      this.modelData.forEach((e, index) => {
        if (i === index) {
          this.modelData[index].stat = true;
        } else {
          this.modelData[index].stat = false;
        }
      });
    }
  }

  getZaikoShaten() {
    this.shatendisplay = true;
    this.shatens = [];
    this._planService.getzaikoShaten().subscribe(res => {
      //  console.log(res);
      this.shatens = res;
      this.zaikoShatenCd = this.shatens[0].shatenCd;
      // res.forEach((val, i) => {
      //   this.tantous.push({ staffCd: val.staffCd, staffNm: val.staffNm, staffstat: false });
      // });
    });
  }

  getKyoten() {
    // this.display = true;
    this.kyotendisplay = true;
    if (this.hanbaiKyotenCd == null) {
      this.kyotens = [];
      this._planService.getkyotens().subscribe((res: Kyotens[]) => {
        this.kyotens.push({
          kyotenCd: '000',
          kyotenNm: '未選択',
          kyostat: false
        });
        res.forEach((val, i) => {
          this.kyotens.push({
            kyotenCd: val.kyotenCd,
            kyotenNm: val.kyotenNm,
            kyostat: false
          });
        });
      });
    }
  }

  kyotenSelected(kyoten: any, event: any) {
    if (kyoten.kyotenCd === '000') {
      setTimeout(() => {
        this.kyotens.forEach((val, i) => {
          if (kyoten.kyotenCd !== val.kyotenCd) {
            this.kyotens[i].kyostat = false;
          }
          // console.log('​val', val);
        });

        this.hanbaiKyotenNm = '';
        this.hanbaiTantouNm = '';
        this.hanbaiKyotenCd = null;
        this.hanbaiTantouCd = null;
        this.oncloseDialog(event);
      }, 500);
    } else {
      // console.log('​kyostat', kyoten.kyostat);

      const index = this.kyotens.findIndex(e => e.kyotenCd === kyoten.kyotenCd);
      setTimeout(() => {
        if (index > -1 && this.kyotens[index].kyostat) {
          this.hanbaiKyotenCd = kyoten.kyotenCd;
          this.hanbaiTantouCd = null;
          this.hanbaiKyotenNm = kyoten.kyotenNm;
          this.hanbaiTantouNm = '';

          this.oncloseDialog(event);
          this.display = false;
        } else if (index > -1 && !this.kyotens[index].kyostat) {
          this.hanbaiKyotenNm = '';
          this.hanbaiTantouNm = '';
          this.hanbaiKyotenCd = null;
          this.hanbaiTantouCd = null;
          this.oncloseDialog(event);
          this.display = false;
        }
      }, 500);

    }
  }

  checkedKyotenSelected(event: any, i: any) {
    this.modelIndexForClear = i;
    console.log(event + ' ' + i);

    if (this.kyotens[i].kyostat === event) {
      this.kyotens[i].kyostat = false;
      // this.carvalue.modelNm = null;
      this.hanbaiKyotenCd = null;
    } else {
      for (let i = 0; i < this.kyotens.length; i++) {
        this.kyotens[i].kyostat = false;
      }
      this.kyotens[i].kyostat = true;
    }
  }

  displayTantou() {
    this.tantoudisplay = true;
    if (this.tantous.length === 0) {
      this.getTantou();
    }
  }

  getTantou() {
    // if (this.hanbaiTantouCd === null) {
    this.tantous = [];
    this._planService.getStaffname().subscribe(res => {
      if (res) {
        this.tantous.push({
          staffCd: '000',
          staffNm: '未選択',
          staffstat: false
        });
        res.forEach((val, i) => {
          this.tantous.push({
            staffCd: val.staffCd,
            staffNm: val.staffNm,
            staffstat: false
          });
        });
      }
    });
    // }
  }

  tantouSelected(tantou: any, event: any) {
    if (tantou.staffCd === '000') {
      setTimeout(() => {
        // this.tantous.forEach((val, i) => {
        //   if (tantou.staffCd !== val.staffCd) {
        //     this.kyotens[i].kyostat = false;
        //   }
        // });
        this.hanbaiTantouNm = '';
        this.hanbaiTantouCd = null;
        this.oncloseDialog(event);
      }, 500);
    } else {
      // setTimeout(() => {
      //   this.hanbaiTantouCd = tantou.staffCd;
      //   this.hanbaiTantouNm = tantou.staffNm;
      //   // this.kyotens = kyoten;
      //   console.log(tantou);
      //   this.oncloseDialog(event);
      //   this.display = false;
      // }, 500);

      const index = this.tantous.findIndex(e => e.staffCd === tantou.staffCd);
      setTimeout(() => {
        if (index > -1 && this.tantous[index].staffstat) {
          this.hanbaiTantouCd = tantou.staffCd;
          this.hanbaiTantouNm = tantou.staffNm;
          this.oncloseDialog(event);
          this.display = false;
        } else if (index > -1 && !this.tantous[index].staffstat) {
          this.hanbaiTantouCd = null;
          this.hanbaiTantouNm = '';
          this.oncloseDialog(event);
          this.display = false;
        }
      }, 500);

    }
  }

  checkedTantouSelected(event: any, i: any) {
    this.modelIndexForClear = i;
    console.log(event + ' ' + i);

    if (this.tantous[i].staffstat === event) {
      this.tantous[i].staffstat = false;
      // this.carvalue.modelNm = null;
      this.hanbaiKyotenCd = null;
    } else {
      for (let i = 0; i < this.tantous.length; i++) {
        this.tantous[i].staffstat = false;
      }
      this.tantous[i].staffstat = true;
    }
  }

  checkLanguage() {
    if (this._planService.checkJapan(this.mitsumoriNovalue)) {
      this.mitsumoriNovalue = '';
      console.log('This is Japan', this.mitsumoriNovalue);
    } else {
      console.log('This is not Japann', this.mitsumoriNovalue);
    }
  }

  checkLanguage2() {
    if (this._planService.checkJapan(this.zaikoKanriCd)) {
      this.zaikoKanriCd = '';
      console.log('This is Japan', this.zaikoKanriCd);
    } else {
      console.log('This is not Japann', this.zaikoKanriCd);
    }
  }

  onPagination(page: number) {
    this.selectedRow = null;
    this.selectdata = null;
    this.page = page - 1;
    this.listData = this.searchChunk[this.page];
  }

  // onRowDblclick(event) {
  //   console.log(event)
  // }

  ngOnDestroy() {
    if (this.estimatesItemSubscription) {
      this.estimatesItemSubscription.unsubscribe();
    }
    if (this.makersSubscription) {
      this.makersSubscription.unsubscribe();
    }
    if (this.modelsSubscription) {
      this.modelsSubscription.unsubscribe();
    }
    if (this.makerFilterSubscription) {
      this.makerFilterSubscription.unsubscribe();
    }
    if (this.modelFilterSubscription) {
      this.modelFilterSubscription.unsubscribe();
    }
    if (this.listdatacustomersSubscription) {
      this.listdatacustomersSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/plan/quotation-search/quotation-search.component.ts